import { render, staticRenderFns } from "./AXprogramagrupos.vue?vue&type=template&id=f14f93c6"
import script from "./AXprogramagrupos.vue?vue&type=script&lang=js"
export * from "./AXprogramagrupos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports